// Style the Shopify Forms app
(function() {
  const injectCustomFormStyles = () => {
    // 1. Target the host element from your screenshot
    const shadowHost = document.querySelector('shopify-forms-embed#app-embed');

    if (shadowHost && shadowHost.shadowRoot) {
      // Check if we've already injected the styles to avoid duplicates
      if (shadowHost.shadowRoot.querySelector('.custom-form-styles')) return;

      const style = document.createElement('style');
      style.classList.add('custom-form-styles');
      
      // 2. Add your custom CSS here
      style.textContent = `
        /* Variables */
        :host {
          --form-background-color: transparent;
          --form-field-border-radius: 0;
          --button-border-radius: 2px;
          --button-padding: 10px;
        }

        /* Container */
        section[data-sizing="form-wrapper"] {
          max-width: 550px !important;
          margin: 0 !important;
        }

        /* Move the newsletter signup checkbox to the end of the form */
        div[class*="CheckboxContainer"] {
          order: 1;
        }

        button {
          order: 2 !important;
          font-family: var(--font-button-family) !important;
          letter-spacing: .1em !important;
          text-transform: uppercase !important;
          font-size: var(--font-body-size) !important;
        }

        /* Labels & input fields */
        input[class*="formInputField_"] {
          padding-top: 8px !important;
          padding-bottom: 5px !important;
          padding-left: 20px !important;
          margin-bottom: 32px !important;
          box-shadow: none !important;
          border-bottom: 1px solid rgba(147, 147, 147, .7) !important;
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
        }

        label[class*="formInputFieldLabel_"] {
          top: -15px !important;
          left: 5px !important;
          font-family: var(--font-accent-family) !important;
          font-size: var(--font-body-size) !important;
          color: var(--body-text-color) !important;
          transform: none !important;
        }

        div[class*="formFieldContainer_"]:focus-within label[class*="formInputFieldLabel_"] {
          transform: none !important;
        }

        textarea {
          margin-top: 10px;
          box-shadow: none !important;
          border: 1px solid #939393 !important;
          padding: 18px !important;
          padding-top: 15px !important;
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
          height: 167px;
          box-sizing: border-box;
        }

        /* Newsletter sign up */
        div[class*="consentCheckboxContainer"] {
          padding: 3px 0 !important;
        }
        
        label#emailConsent-true-label span {
          font-family: var(--font-accent-family) !important;
          font-size: var(--font-body-size) !important;
        }

        /** Custom Newsletter Checkbox Styling **/
        /* Visually hide the native checkbox input while keeping it accessible and focusable. */
        #emailConsent-true {
          appearance: none;
          -webkit-appearance: none;
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
        }

        /* Setup the label for relative positioning and vertical alignment */
        #emailConsent-true-label {
          position: relative;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          gap: 0;
        }

        /* Custom Outer Box (Frame) */
        #emailConsent-true-label::before {
          content: "";
          display: inline-block;
          width: 12px; 
          height: 12px; 
          margin-right: 8px; 
          border: 1px solid #939393; 
          box-sizing: border-box; 
        }

        /* Custom Inner Check (Fill) */
        #emailConsent-true-label::after {
          content: "";
          position: absolute; 
          left: 2px;
          top: 50%; 
          transform: translateY(-50%); 
          width: 8px;
          height: 8px;
          background-color: #302F2F; 
          display: block;
          opacity: 0;
          transition: opacity 0.2s ease;
          box-sizing: border-box; 
        }

        /* State when checked: Show the inner filled box. */
        #emailConsent-true-label:has(#emailConsent-true:checked)::after {
          opacity: 1; 
        }

        /* Focus state for accessibility (using focus-visible so it primarily shows on keyboard navigation). */
        #emailConsent-true-label:has(#emailConsent-true:focus-visible)::before {
          outline: 2px solid #302F2F; 
          outline-offset: 2px;
        }

        /* Disclaimer text */
        div[class*="formDisclaimer_"] {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-size-small) !important;
        }

        div[class*="formDisclaimer_"] a {
          text-decoration: none !important;
        }

        /* Success message */
        section[data-testid="banner-success"] {
          margin-top: 0 !important;
        }
        
        section[data-testid="banner-success"] h2 {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
          text-transform: uppercase !important;
        }

        section[data-testid="banner-success"] div[class*="textBody_"] {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
        }

        @media screen and (max-width: 989px) {
          /* Mobile container padding top */
          div[class*="gridItemContent"] {
            padding-top: 2px !important;
            padding-bottom: 56px !important;
          }

          /* Input fields */
          input[class*="formInputField_"] {
            margin-bottom: 20px !important;
          }

          /* Disclaimer text */
          div[class*="formDisclaimer_"] p {
            padding-left: 20px;
            padding-right: 20px;
          }
        }

        @media screen and (min-width: 990px) {
          /* Desktop container padding top */
          div[class*="gridItemContent"] {
            padding-top: 12px !important;
          }
        }
      `;

      shadowHost.shadowRoot.appendChild(style);
      console.log('Shopify Form styles injected successfully.');
    }

      // Finds the first textarea found inside the shadow root and adds placeholder text
      const messageField = shadowHost.shadowRoot.querySelector('textarea');
      if (messageField && !messageField.getAttribute('placeholder')) {
        messageField.setAttribute('placeholder', 'Enter message...');
      }

      // Polish translations for the Shopify Forms app.
      // The form renders inside a shadow DOM so it's inaccessible to the
      // Translate & Adapt app — we swap text content directly via JS instead.
      const isPolish = (typeof Shopify !== 'undefined' && Shopify.locale === 'pl')
        || document.documentElement.lang === 'pl';

      if (isPolish) {
        const root = shadowHost.shadowRoot;

        // Helper: find a label by its current text content and replace it
        function translateLabel(englishText, polishText) {
          root.querySelectorAll('label').forEach(function(label) {
            // Labels contain child spans so check textContent broadly
            if (label.textContent.trim().startsWith(englishText)) {
              // Only replace the text node, not child elements (e.g. asterisk spans)
              label.childNodes.forEach(function(node) {
                if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().startsWith(englishText)) {
                  node.textContent = node.textContent.replace(englishText, polishText);
                }
              });
              // Fallback: if label text is directly set (no child nodes)
              if (label.childNodes.length === 1 && label.childNodes[0].nodeType === Node.TEXT_NODE) {
                label.childNodes[0].textContent = label.childNodes[0].textContent.replace(englishText, polishText);
              }
            }
          });
        }

        // Helper: find an element by selector and replace its text content
        function translateEl(selector, polishText) {
          const el = root.querySelector(selector);
          if (el) el.textContent = polishText;
        }

        // Helper: find element by partial text match across any selector
        function translateByText(selector, englishText, polishText) {
          root.querySelectorAll(selector).forEach(function(el) {
            if (el.textContent.trim() === englishText) {
              el.textContent = polishText;
            }
          });
        }

        // Field labels
        translateByText('label', 'Email Address*', 'Adres e-mail*');
        translateByText('label', 'First name*', 'Imię*');
        translateByText('label', 'Last name*', 'Nazwisko*');
        translateByText('label', 'Enquiry*', 'Zapytanie*');
        translateByText('label', 'Sign up to newsletter', 'Zapisz się do newslettera');

        // Textarea placeholder
        if (messageField) {
          messageField.setAttribute('placeholder', 'Wpisz wiadomość...');
        }

        // Submit button
        translateByText('button[type="submit"], button', 'Submit', 'WYŚLIJ');

        // Disclaimer text — contains a link so we target the text node only
        const disclaimer = root.querySelector('div[class*="formDisclaimer_"] p');
        if (disclaimer) {
          disclaimer.childNodes.forEach(function(node) {
            if (node.nodeType === Node.TEXT_NODE) {
              node.textContent = node.textContent
                .replace('Your data will be processed solely for the purpose of responding to your enquiry.', 
                         'Twoje dane będą przetwarzane wyłącznie w celu odpowiedzi na Twoje zapytanie.');
            }
          });
          // Translate the Privacy Policy link text and update href to PL page
          const privacyLink = disclaimer.querySelector('a');
          if (privacyLink) {
            privacyLink.textContent = 'Polityka prywatności';
            privacyLink.href = '/pl/pages/privacy-policy';
          }
        }
      }
  };

  // Observe the document for when the Shopify Form element is added
  const observer = new MutationObserver((mutations, obs) => {
    const form = document.querySelector('shopify-forms-embed#app-embed');
    if (form) {
      injectCustomFormStyles();
      // Optional: keep observing if the form re-renders, 
      // or disconnect if it's a one-time load
      // obs.disconnect(); 
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();